import { render, staticRenderFns } from "./numberTextStyle.vue?vue&type=template&id=2a82d73c&"
import script from "./numberTextStyle.vue?vue&type=script&lang=ts&"
export * from "./numberTextStyle.vue?vue&type=script&lang=ts&"
import style0 from "./numberTextStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports